<a
  *ngIf="text"
  stopPropagation
  [href]="href || 'javascript:void(0)'"
  class="link"
  (click)="onClickLink()"
>
  {{ text }}
</a>
